// extracted by mini-css-extract-plugin
export var avatarContainer = "_ak-0";
export var avatarTypingWave = "_ak-i";
export var gray = "_ak-f";
export var green = "_ak-c";
export var icon = "_ak-9";
export var image = "_ak-1";
export var lg = "_ak-6";
export var md = "_ak-5";
export var presenceDot = "_ak-b";
export var red = "_ak-d";
export var sm = "_ak-4";
export var status = "_ak-a";
export var typingDot = "_ak-h";
export var typingPill = "_ak-g";
export var xl = "_ak-7";
export var xs = "_ak-3";
export var xxl = "_ak-8";
export var xxs = "_ak-2";
export var yellow = "_ak-e";